import { getPreviousVisibleSection } from "../../../questionnaire/utils/getVisibleSection";
import type { QuestionnaireState } from "../../types";

export const handlePreviousSectionAction = (
  state: QuestionnaireState,
): QuestionnaireState => {
  const { sections } = state;
  // Filter out the last section if it is an edit section
  const updatedSections = sections.filter(
    section => section.displayAs !== "edit",
  );

  return {
    ...state,
    sections: updatedSections,
    currentSectionIndex: getPreviousVisibleSection(state),
    isEditing: false,
  };
};
